import React from 'react';
import PropTypes from 'prop-types';

import styles from './GlobalSearch.module.scss';
import Thumbnail from 'components/Thumbnail/Thumbnail';

const typeColors = {
  user: 'var(--theme-color-primary)',
  project: 'var(--theme-color-accent)',
  task_url: 'var(--theme-color-success)',
  task_description: 'var(--theme-color-warning)',
};

const typeIcons = {
  user: '👤',
  project: '📁',
  task_url: '🔗',
  task_description: '📝',
};

const SearchResultIcon = ({ type, image, title }) => {
  if (type === 'user' && image) {
    return (
      <div className={styles.resultIcon}>
        <Thumbnail
          customHeight="32px"
          customWidth="32px"
          src={image || '/dixy.png'}
          alt={title}
          borderRadius="50%"
        />
      </div>
    );
  }

  return (
    <div className={styles.resultIcon}>
      <span
        className={styles.typeIcon}
        style={{ backgroundColor: typeColors[type] }}
      >
        {typeIcons[type]}
      </span>
    </div>
  );
};

SearchResultIcon.propTypes = {
  type: PropTypes.oneOf(['user', 'project', 'task_url', 'task_description'])
    .isRequired,
  image: PropTypes.string,
  title: PropTypes.string,
};

export default SearchResultIcon;
